export default function reducer(state = { freight: { amount: 0, vatRate: 0 } }, action) {
    switch (action.type) {
        case 'GET_FREIGHT':
            return {
                ...state,
            }
        case 'GET_FREIGHT_FAILED':
            return {
                ...state,
                freight: { amount: 0, vatRate: 0 },
            }
        case 'GET_FREIGHT_SUCCESS':
            return {
                ...state,
                freight: action.payload,
            }

        case 'GET_FREIGHT_FOR_ORDER':
            return {
                ...state,
            }
        case 'GET_FREIGHT_FOR_ORDER_FAILED':
            return {
                ...state,
                freight: { amount: 0, vatRate: 0 },
            }
        case 'GET_FREIGHT_FOR_ORDER_SUCCESS':
            return {
                ...state,
                freight: action.payload,
            }
        default:
            return state
    }
}
